export default "__VITE_ASSET__6hKP3k6E__"